<template>

  <div class="form-group">
    <div class="input-group position-relative custom-place-search">
      <TyIcon icon="ty-search" class="search-icon" :color="'var(--first-color)'" width="1.6rem" height="1.6rem"/>
      <input type="text" required name="uni_search" id="uni_search" class="form-control place-item"
             autocomplete="off" autocorrect="off" spellcheck="false" aria-autocomplete="list"
             aria-expanded="false" :placeholder="$t('location-placeholder-custom')"
             :autofocus="!isPhoneDevice"
             :disabled="submitting" @focus="() => {inputFocusIn()}"
             @focusout="inputFocusOut"
             v-model="localPlace" ref="placeInput">
    </div>
  </div>

  <div class="top_search_places">

    <template v-if="!searchingPlace && places && places.count !== undefined">

      <div class="alert alert-warning btn-rounded text-center" v-if="places.count == 0">
        {{ $t('no-location-found') }}
      </div>


      <div v-else>


        <!-- ubytovanie start-->
        <div class="location-select" v-if="places.accommodations.length > 0">
          <p>{{ $t('filter-accommodations-group') }}</p>
          <div class="location-items">
            <div class="col-12 col-lg-6" v-for="accommodation in places.accommodations">
              <NuxtLink
                  class="location-items-group"
                  @click="emit['openAccommodation'](accommodation)"
                  :to="`/${activeLocale.code}-${activeCountry.code.toLowerCase()}/${accommodation.link}`">

                <div class="col-2 image-item">
                  <figure>
                    <template v-if="accommodation.img && accommodation.img.id > 0">
                      <img :src="createImageFromObj(accommodation.img).getTyrionSrc('thumb')"
                           :alt="accommodation.title"
                           class="img-cover img-atraction" width="64" height="64">
                    </template>
                    <TyIcon icon="ty-house" v-else class="me-2 icon-color-dark"></TyIcon>
                  </figure>
                </div>
                <div class="col-8 title-item">
                  <span class="title-item">{{ accommodation.title }}</span>
                  <span class="offer-count">
                    {{ accommodation.city }}<br>
                    {{ accommodation.tourist_region_lang && accommodation.tourist_region_lang[activeLocale.code] ? accommodation.tourist_region_lang[activeLocale.code] : accommodation.tourist_region }},
                    {{ !accommodation.country_lang || accommodation.country_lang[activeLocale.code] === undefined || accommodation.country_lang[activeLocale.code].length === 0 ? accommodation.country : accommodation.country_lang[activeLocale.code] }}
                  </span>
                </div>
              </NuxtLink>
            </div>
          </div>
        </div>
        <!-- ubytovanie end -->

        <!-- kraje a regiony start -->
        <div class="location-select" v-if="places.districts.length > 0 || places.touristic_regions.length > 0">
          <p class="location-select-title">{{ $t('districts-and-regions') }}</p>
          <div class="location-items">
            <div class="col-12 col-lg-6" v-for="region in places.touristic_regions">
              <div class="location-items-group pointer"
                   @click="selectPlace('tourist_region', region)">

                <div class="col-2 image-item">
                  <figure>
                    <template v-if="region.img && region.img.id > 0">
                      <img :src="createImageFromObj(region.img).getTyrionSrc('thumb')"
                           :alt="region.title"
                           class="img-cover img-atraction" width="64" height="64">
                    </template>
                    <TyIcon icon="ty-region" width="1.5rem" height="1.5rem" v-else></TyIcon>
                  </figure>
                </div>
                <div class="col-8 title-item">
                  <div class="title-item">
                    {{
                      !region.langtitle || region.langtitle[activeLocale.code] === undefined || region.langtitle[activeLocale.code].length === 0 ? region.title : region.langtitle[activeLocale.code]
                    }}
                  </div>
                  <span class="offer-count">
                    {{
                      !region.country_lang || region.country_lang[activeLocale.code] === undefined || region.country_lang[activeLocale.code].length === 0 ? region.country : region.country_lang[activeLocale.code]
                    }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6" v-for="district in places.districts">
              <div class="location-items-group pointer"
                   @click="selectPlace('district', district)">

                <div class="col-2 image-item">
                  <figure>
                    <TyIcon icon="ty-region-2" width="1.5rem" height="1.5rem"></TyIcon>
                  </figure>
                </div>
                <div class="col-8 title-item">
                  <div class="title-item">{{ district.title }}</div>
                  <span class="offer-count">
                    {{
                      !district.country_lang || district.country_lang[activeLocale.code] === undefined || district.country_lang[activeLocale.code].length === 0 ? district.country : district.country_lang[activeLocale.code]
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- kraje a regiony end -->


        <!-- mesta start -->
        <div class="location-select" v-if="places.cities.length > 0">
          <p class="location-select-title">{{ $t('cities') }}</p>
          <div class="location-items">
            <div class="col-12 col-lg-6" v-for="city in places.cities">
              <div class="location-items-group pointer"
                   @click="selectPlace('city', city)">

                <div class="col-2 image-item">
                  <figure>

                    <TyIcon icon="ty-city-5" width="1.5rem" height="1.5rem"></TyIcon>
                  </figure>
                </div>
                <div class="col-8 title-item">
                  <div class="title-item">{{ city.title }}</div>
                  <div class="offer-count">
                    {{ city.district }},
                    {{ !city.country_lang || city.country_lang[activeLocale.code] === undefined || city.country_lang[activeLocale.code].length === 0 ? city.country : city.country_lang[activeLocale.code] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- mesta end -->

        <!-- atrakcie start -->
        <div class="location-select" v-if="places.attractions.length > 0">
          <p class="location-select-title">{{ $t('filter-attractions-group') }}</p>
          <div class="location-items">
            <div class="col-12 col-lg-6" v-for="attraction in places.attractions">
              <div class="location-items-group"
                   @click="selectPlace('attraction', attraction)">

                <div class="col-2 image-item">
                  <figure>
                    <template v-if="attraction.img && attraction.img.id > 0">
                      <img :src="createImageFromObj(attraction.img).getTyrionSrc('thumb')"
                           :alt="attraction.title"
                           class="img-cover img-atraction" width="64" height="64">
                    </template>
                    <TyIcon icon="ty-region-3" width="1.5rem" height="1.5rem" v-else></TyIcon>
                  </figure>
                </div>
                <div class="col-8 title-item">
                  <div class="title-item">
                    {{attraction.langtitle[activeLocale.code] === undefined || attraction.langtitle[activeLocale.code].length === 0 ? attraction.title : attraction.langtitle[activeLocale.code]}}
                  </div>
                  <div class="offer-count">
                    {{ !attraction.region_lang || attraction.region_lang[activeLocale.code] === undefined || attraction.region_lang[activeLocale.code].length === 0 ? attraction.country : attraction.region_lang[activeLocale.code] }},
                    {{ !attraction.country_lang || attraction.country_lang[activeLocale.code] === undefined || attraction.country_lang[activeLocale.code].length === 0 ? attraction.country : attraction.country_lang[activeLocale.code] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- atrakcie end -->

      </div>
    </template>
  </div>

</template>

<script setup lang="ts">

import {useStateFunctionBodyClass} from "../../../../../../composables/state/body_class";
import {computed, ref, watch} from "vue";
import Image from "../../../../../../lib/models/Image";
import {useNuxtApp} from "#app";

const {updateBodyClass, removeBodyClass} = useStateFunctionBodyClass();

const props = defineProps({
  submitting: Boolean,
  searchingPlace: Boolean,
  place: String,
  activeLocale: {code: String},
  activeCountry: {code: String},
  placeObj: {id: Number, type: String, title: String} | null,
  places: {
    cities: Array<{ id: string, title: string, type: string }>,
    districts: Array<{ id: string, title: string, type: string }>,
    touristic_regions: Array<{ id: string, title: string, langtitle: { [k: string]: string } }>
  } | null
})
const localPlace = ref(props.place);
const placeInput = ref(null);
const emit = defineEmits(['openAccommodation', 'update:place', 'update:placeObj']);
const {$isDesktop} = useNuxtApp();

watch(localPlace, (newValue) => {
  emit('update:place', newValue);
});

watch(() => props.place, (newPlace) => {
  localPlace.value = newPlace;
});

const inputFocusIn = () => {
  updateBodyClass('input-focus');
}
const inputFocusOut = () => {
  removeBodyClass('input-focus');
}
const isPhoneDevice = computed(() => {
  return !$isDesktop();
});

const selectPlace = (type, obj) => {
  emit('update:place', obj.title);
  emit('update:placeObj', {...obj, ...{type: type}});
}

const focusCustomPlaceInput = () => {
  if (placeInput.value) {
    placeInput.value.focus();
  }
}

const createImageFromObj = (data) => {
  return new Image().fromObject(data);
}

defineExpose({
  focusCustomPlaceInput,
});

</script>
